import React, { Component } from 'react';
import { ReactComponent as SendButton } from 'Icons/sendIcon.svg';
class SendIcon extends Component {

  render() {
    return (
    <button
      onFocus={this.props.onFocus}
      onBlur={this.props.onBlur}
      onClick={(e) => { e.preventDefault(); this.props.onClick(e); }}
      className="sc-user-input--send-icon-wrapper"
    >
      <SendButton />
    </button>
    );
  }
}

export default SendIcon;
